import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mathFloor",
})
export class MathFloorPipe implements PipeTransform {
  transform(value: number): number {
    if (Number.isNaN(value)) {
      return 0;
    }
    return Math.floor(value);
  }
}
